import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as StairsIcon } from "../assets/icons/user2/stairs.svg";
import { ReactComponent as ElevatorIcon } from "../assets/icons/user2/elevator.svg";

export default function TransferPromptModal({ kind, instruction, onNext, onBack, onScan }) {
  const { t } = useTranslation();
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);

  return (
    <dialog
      ref={dialogRef}
      aria-labelledby="transfer-prompt-title"
      aria-describedby="transfer-prompt-description"
      onCancel={(event) => { event.preventDefault(); onBack(); }}
      className="fixed inset-0 m-auto w-[calc(100%-2rem)] max-w-sm max-h-[90dvh] overflow-y-auto rounded-3xl border border-slate-100 bg-white p-6 text-center shadow-2xl backdrop:bg-slate-900/60 backdrop:backdrop-blur-sm"
    >
      <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full border-4 border-blue-100 bg-blue-50 text-blue-600 shadow-inner" aria-hidden="true">
        {kind === "stair" ? <StairsIcon className="h-9 w-9" /> : kind === "elevator" ? <ElevatorIcon className="h-9 w-9" /> : <span className="text-4xl">↔</span>}
      </div>
      <h2 id="transfer-prompt-title" className="text-xl font-extrabold leading-snug text-slate-900">
        {t(`user.navigation.transferPrompt.${kind}`)}
      </h2>
      <p className="mt-3 rounded-2xl border border-blue-100 bg-blue-50 p-3 text-sm font-bold leading-relaxed text-blue-700">{instruction}</p>
      <p id="transfer-prompt-description" className="mt-4 text-sm leading-relaxed text-slate-500">
        {t(`user.navigation.transferPrompt.${kind === "bridge" ? "bridgeInstruction" : "floorInstruction"}`)}
      </p>
      <div className="mt-6 grid grid-cols-2 gap-3">
        <button type="button" onClick={onBack} className="h-12 rounded-xl border border-slate-300 bg-white font-bold text-slate-700 hover:bg-slate-50">
          {t("user.navigation.transferPrompt.back")}
        </button>
        <button type="button" onClick={onNext} className="h-12 rounded-xl bg-blue-600 font-bold text-white shadow-lg shadow-blue-500/25 hover:bg-blue-700">
          {t("user.navigation.nextStep", "ถัดไป")}
        </button>
      </div>
      {onScan && (
        <button type="button" onClick={onScan} className="mt-4 min-h-11 w-full rounded-xl text-sm font-bold text-blue-600 hover:bg-blue-50">
          {t("user.navigation.transferPrompt.scan")}
        </button>
      )}
    </dialog>
  );
}
